import styled from 'styled-components'
import theme from '../../../../styles/theme'

export const Wrapper = styled.div``
export const Header = styled.div`
  border-radius: 8px 8px 0px 0px;
  height: 50%;
  background-color: ${theme.colors.secondary};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 36px;
  padding: 24px;
`
export const Body = styled.div`
  margin: 36px;
  padding: 24px;
  -webkit-box-pack: justify;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  .modal-click {
    font-weight: bold;
    color: ${theme.colors.blue};
    cursor: pointer;
  }
  span {
    margin: 0.5%;
  }
`
